export const navLinks = [
  { label: '今日索引', href: '#index' },
  { label: '热门推荐', href: '#featured' },
  { label: '分区合集', href: '#zones' },
  { label: '独家线索', href: '#leads' },
  { label: '群组互换', href: '#groups' },
];

export const tickerItems = [
  '第 018 期已更新：本期聚焦「如何判断一条线索是否值得深挖」',
  '今日新增 128 条线索，其中独家方向 9 条',
  '群组登记处完成本周核验，下架失联群组 4 个',
  '老帖档案馆新增 2024 年 3 月整月归档索引',
];

export const indexEntries = [
  {
    no: '01',
    name: '深夜瓜田',
    tag: '图文线索',
    desc: '每晚十点后汇总的爆料图文合集，按时间线排布，方便一口气补完一整晚的更新。',
    time: '22:40',
  },
  {
    no: '02',
    name: '吃瓜情报站',
    tag: '热点追踪',
    desc: '当日关注度最高的事件整理与补充线索，标注来源与时间，便于前后对照还原全貌。',
    time: '21:15',
  },
  {
    no: '03',
    name: '影像收录馆',
    tag: '图集专区',
    desc: '高清图集与现场记录分区存放，支持按事件归档查阅，回看时不必再翻聊天记录。',
    time: '20:05',
  },
  {
    no: '04',
    name: '线索交换所',
    tag: '资源互换',
    desc: '以私信为主的互换入口，发布需求前建议先读完互换说明，避免无效沟通。',
    time: '19:30',
  },
  {
    no: '05',
    name: '老帖档案馆',
    tag: '往期合集',
    desc: '按月份归档的历史帖子索引，适合回头补充遗漏内容，也方便新来的瓜友快速入坑。',
    time: '18:50',
  },
  {
    no: '06',
    name: '瓜友笔记',
    tag: '长文速读',
    desc: '把动辄上万字的长贴提炼成要点摘要，几分钟看完一篇深度吃瓜长文的核心脉络。',
    time: '17:20',
  },
  {
    no: '07',
    name: '群组登记处',
    tag: '群组索引',
    desc: '收录仍在活跃的交流群组索引，每日核验一次状态，失联的会及时标注并下架。',
    time: '16:10',
  },
  {
    no: '08',
    name: '爆料风向',
    tag: '每周盘点',
    desc: '本周关注度最高的线索方向盘点，附简要解读，帮你判断下周该盯哪条线。',
    time: '15:00',
  },
];

export const featuredItems = [
  {
    id: 'featured-main',
    rank: '本期主推',
    title: '吃瓜情报站',
    tag: '热点追踪',
    desc: '把一天里散落在各个角落的爆料整理成一条可回溯的时间线，每条都标注时间与来源，读起来像翻一本当天出版的杂志。',
    meta: '更新于 21:15 · 共 38 条图文',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20editorial%20flat%20lay%20of%20a%20busy%20night%20desk%20with%20an%20open%20notebook%2C%20printed%20photos%2C%20reading%20glasses%20and%20a%20cup%20of%20tea%2C%20amber%20lamp%20glow%2C%20cream%20paper%20textures%2C%20top%20down%20composition%2C%20muted%20crimson%20and%20olive%20accents%2C%20cinematic%20soft%20light&width=1200&height=800&seq=hg-feat-big&orientation=landscape',
    alt: '吃瓜情报站 黑料网址热门推荐 图文整理',
  },
  {
    id: 'featured-01',
    rank: '编辑推荐',
    title: '深夜瓜田',
    tag: '图文线索',
    desc: '夜里最热闹的更新集合，越晚越有料。',
    meta: '22:40 更新',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20nighttime%20stack%20of%20printed%20documents%20and%20folders%20under%20a%20warm%20amber%20desk%20lamp%2C%20dark%20cream%20tones%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20calm%20organized%20mood&width=800&height=600&seq=hg-feat-1&orientation=landscape',
    alt: '深夜瓜田 黑料网址分享 图文线索',
  },
  {
    id: 'featured-02',
    rank: '图集',
    title: '影像收录馆',
    tag: '图集专区',
    desc: '按事件归档的高清图集，回看更省事。',
    meta: '20:05 更新',
    image:
      'https://readdy.ai/api/search-image?query=Collection%20of%20small%20framed%20photographs%20arranged%20on%20a%20warm%20cream%20plaster%20wall%2C%20gallery%20reading%20corner%20feel%2C%20soft%20natural%20daylight%2C%20muted%20amber%20and%20olive%20accents%2C%20minimal%20editorial%20composition&width=800&height=600&seq=hg-feat-2&orientation=landscape',
    alt: '影像收录馆 黑料网址推荐 图集专区',
  },
  {
    id: 'featured-03',
    rank: '归档',
    title: '老帖档案馆',
    tag: '往期合集',
    desc: '按月归档的历史索引，补漏首选。',
    meta: '18:50 更新',
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20wooden%20archive%20shelves%20filled%20with%20labeled%20storage%20boxes%20and%20index%20cards%2C%20warm%20amber%20lighting%2C%20orderly%20library%20atmosphere%2C%20editorial%20photography%2C%20soft%20shadows%2C%20cream%20and%20brown%20palette&width=800&height=600&seq=hg-feat-3&orientation=landscape',
    alt: '老帖档案馆 黑料网址交流 往期合集',
  },
  {
    id: 'featured-04',
    rank: '交流',
    title: '群组登记处',
    tag: '群组索引',
    desc: '仍在活跃的交流群组，每日核验。',
    meta: '16:10 更新',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20arrangement%20of%20glazed%20ceramic%20mugs%2C%20scattered%20handwritten%20notes%20and%20a%20folded%20scarf%20on%20natural%20linen%2C%20warm%20morning%20light%2C%20muted%20cream%20and%20amber%20palette%2C%20editorial%20still%20life%20photography&width=800&height=600&seq=hg-feat-4&orientation=landscape',
    alt: '群组登记处 黑料网址群组 交流索引',
  },
];

export const categoryZones = [
  {
    no: '01',
    name: '深夜吃瓜',
    count: '132 条线索',
    desc: '越晚越热闹的图文汇总区，适合睡前慢慢刷。',
    tone: 'primary',
  },
  {
    no: '02',
    name: '影像合集',
    count: '87 组图集',
    desc: '按事件归档的高清图集与现场记录。',
    tone: 'plain',
  },
  {
    no: '03',
    name: '线索情报',
    count: '64 份线索',
    desc: '来源可循、时间明确的独家情报方向。',
    tone: 'accent',
  },
  {
    no: '04',
    name: '资源互换',
    count: '210 次互换',
    desc: '以私信完成的有效资源互换入口。',
    tone: 'secondary',
  },
];

export const exclusiveLeads = [
  {
    date: '09 / 12 22:40',
    title: '一条被反复删改的时间线',
    text: '同一事件在三处出现时间对不上的说法，整理成对照表后，反而比结论更有参考价值。',
    tags: ['时间线', '待验证'],
  },
  {
    date: '09 / 12 20:15',
    title: '被忽略的现场侧拍',
    text: '主流图集都裁掉了画面左侧的细节，把原图调亮后能看清背景里的关键信息。',
    tags: ['图集', '补充线索'],
  },
  {
    date: '09 / 11 23:05',
    title: '关于来源可信度的一次讨论',
    text: '群里有瓜友整理了一套判断来源是否可靠的小清单，已收入「瓜友笔记」长期备查。',
    tags: ['方法论', '群组讨论'],
  },
  {
    date: '09 / 11 19:30',
    title: '往期归档里翻出的旧线索',
    text: '老帖档案馆补档时发现一条两年前的记录，和本周的热点方向意外咬合上了。',
    tags: ['归档', '旧线索'],
  },
  {
    date: '09 / 10 21:50',
    title: '一份匿名投稿的处理说明',
    text: '投稿内容短期无法交叉验证，先收入待核对区，验证通过后再并入今日索引。',
    tags: ['投稿', '核对中'],
  },
];

export const groupList = [
  {
    name: '吃瓜夜校',
    tag: '交流群',
    members: '320 人',
    status: '活跃',
    desc: '主打夜间闲聊与线索补充，气氛轻松，禁止刷屏。',
  },
  {
    name: '图集互换处',
    tag: '资源互换',
    members: '186 人',
    status: '活跃',
    desc: '以高清图集互换为主，入群前请先阅读互换说明。',
  },
  {
    name: '线索侦探社',
    tag: '深度讨论',
    members: '94 人',
    status: '活跃',
    desc: '偏重方法论与来源核对，适合喜欢深挖的瓜友。',
  },
  {
    name: '老帖补档组',
    tag: '归档协作',
    members: '142 人',
    status: '活跃',
    desc: '合力整理往期归档索引，欢迎提供缺失记录。',
  },
  {
    name: '深夜电台',
    tag: '闲聊群',
    members: '210 人',
    status: '限流',
    desc: '声控与闲聊为主，偶尔同步当日爆料风向。',
  },
  {
    name: '新人引导处',
    tag: '入坑指南',
    members: '458 人',
    status: '活跃',
    desc: '面向第一次来的瓜友，先看指南再进主群。',
  },
];

export const rhythmStats = [
  { value: '128', label: '今日新增线索', unit: '条' },
  { value: '1,042', label: '累计收录站点', unit: '个' },
  { value: '26', label: '活跃交流群组', unit: '个' },
  { value: '每日 22:00', label: '固定更新时段', unit: '' },
];

export const indexHighlights = [
  '只看今天值得花时间的 8 个点位',
  '按更新时间倒序，不必逐群翻找',
  '每条都标注线索方向与补充入口',
];